// extracted by mini-css-extract-plugin
module.exports = {"Container":"edpuzzle_signature-module--Container--3WuWF","WrittenBy":"edpuzzle_signature-module--WrittenBy--3nk00","Category":"edpuzzle_signature-module--Category--UxPzL"};